import { ITextDetail, ITextDisable, ITextState, ITextTable, ITextTablePagination } from "@/types/components/translation";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const widgetTextTableInitial: ITextTable[] = []

const widgetTextPaginationInitial:ITextTablePagination = {
    page: 1,
    perPage: 25,
    hasNext: true,
    hasPrevious: false,
}

const widgetTextDetailInitial: ITextDetail = {}

const widetTextStateInitial: ITextState = {
    isSaving: false
}

const widgetTextDisableInitial: ITextDisable = {
    isDisableManageLanguage: false,
}

const initialState = {
    widgetTextTableSettings: widgetTextTableInitial,
    widgetTextPaginationSettings: widgetTextPaginationInitial,
    widgetTextDetail: widgetTextDetailInitial,
    widgetTextDetailBackup: widgetTextDetailInitial,
    widgetTextState: widetTextStateInitial,
    widgetTextDisable: widgetTextDisableInitial
}

const widgetTextSlice = createSlice({
    name: 'widgetText',
    initialState,
    reducers: {
        handleSaveWidgetTextTableSettings: (state, action: PayloadAction<ITextTable[]>) => {
            state.widgetTextTableSettings = action.payload;
        },
        handleSaveWidgetTextPaginationSettings: (state, action: PayloadAction<Partial<ITextTablePagination>>) => {
            state.widgetTextPaginationSettings = { ...state.widgetTextPaginationSettings, ...action.payload };
        },
        handleSaveWidgetTextDetail: (state, action: PayloadAction<ITextDetail>) => {
            state.widgetTextDetail = { ...state.widgetTextDetail, ...action.payload };
        },
        handleSaveWidgetTextDetailBackup: (state, action: PayloadAction<ITextDetail>) => {
            state.widgetTextDetailBackup = { ...state.widgetTextDetailBackup, ...action.payload };
        },
        handleSetWidgetTextState: (state, action: PayloadAction<ITextState>) => {
            state.widgetTextState = { ...state.widgetTextState, ...action.payload };
        },
        handleResetWidgetTextDetail: (state) => {
            state.widgetTextDetail = state.widgetTextDetailBackup
        },
        handleResetWidgetTextState: (state) => {
            state.widgetTextState = widetTextStateInitial
        },
        handleSetWidgetTextDisable: (state, action: PayloadAction<ITextDisable>) => { 
            state.widgetTextDisable = { ...state.widgetTextDisable, ...action.payload };
        }
    }
})

export const widgetTextTableSettingSelector = createSelector(
    (state: RootState) => state.widgetText,
    (state) => state.widgetTextTableSettings,
);

export const widgetTextPaginationSettingSelector = createSelector(
    (state: RootState) => state.widgetText,
    (state) => state.widgetTextPaginationSettings,
);

export const widgetTextDetailSelector = createSelector(
    (state: RootState) => state.widgetText,
    (state) => state.widgetTextDetail,
)

export const widgetTextDetailBackupSelector = createSelector(
    (state: RootState) => state.widgetText,
    (state) => state.widgetTextDetailBackup,
)

export const widgetTextStateSelector = createSelector(
    (state: RootState) => state.widgetText,
    (state) => state.widgetTextState,
)

export const widgetTextDisableSelector = createSelector((state: RootState) => state.widgetText, (state) => state.widgetTextDisable)

export const {
    handleSaveWidgetTextTableSettings,
    handleSaveWidgetTextPaginationSettings,
    handleSaveWidgetTextDetail,
    handleSaveWidgetTextDetailBackup,
    handleResetWidgetTextDetail,
    handleSetWidgetTextState,
    handleResetWidgetTextState,
    handleSetWidgetTextDisable
} = widgetTextSlice.actions

export default widgetTextSlice;